export function formatRedirectionUrl(url, { url_params, user_country_host }) {
  let separator = url.includes("?") ? "&" : "?";
  const query = url_params ? new URLSearchParams(url_params).toString() : "";
  separator = !query ? "" : separator;
  if (user_country_host) {
    return `https://${user_country_host}${url}${separator}${query}`;
  }
  return `${url}${separator}${query}`;
}
